// extracted by mini-css-extract-plugin
export default {"ButtonAddToCart":"ButtonAddToCart_ButtonAddToCart__4668B"};